<ng-container *ngIf="isActivated; else mainHtml">
  <ng-container *ngIf="htmlValueRef">
    <div class="foo-tooltip-container" [style.width]="containerWidth"
         (mouseover)="!dataShimmer && showTitleTooltip(element)"
         (mouseleave)="hideTitleTooltip(element)"
         (touchstart)="$event.stopPropagation();!dataShimmer && showTitleTooltip(element)"
         (touchend)="hideTitleTooltip(element)"
         #element>
      <div [class.foo-tooltip-element]="!isInDynamicListing" [class.foo-tooltip-no-title]="!tooltipOptions.title">
        <ng-container *ngTemplateOutlet="htmlValueRef; context : { tooltipConfigs: tooltipConfigs}"></ng-container>
      </div>
    </div>
  </ng-container>
</ng-container>
<ng-template #mainHtml>
    <ng-container *ngTemplateOutlet="htmlValueRef; context : { tooltipConfigs: tooltipConfigs}"></ng-container>
</ng-template>
